import { getPeriodsDurationInMinutes } from 'components/employee-portal/work-pattern/utils';
import dayjs from 'dayjs';
import { formatMinutesInHours } from 'utils/date';
import { createPeriods } from '../TimePeriods.utils';
import { CreateDutyProps, Duty } from './types';
import { v4 as uuidv4 } from 'uuid';

export const createDuty = ({
  timePeriods,
  dutyHourType,
  workAgreement,
  planUnit
}: CreateDutyProps): Duty => ({
  id: uuidv4(),
  periods: createPeriods({
    periodStartDate: dayjs().startOf('day').toDate(),
    timePeriods,
    dutyHourTypeId: dutyHourType?.dutyHourTypeId
  }),
  workAgreement,
  planUnit
});

export const getDutyDuration = (duty: Duty) =>
  formatMinutesInHours(getPeriodsDurationInMinutes(duty.periods));
